import BaseError from './BaseError'

// ログインが必要な API などをログインしてない or 無効なトークンで叩いた場合のエラー
export default class UnauthenticatedError extends BaseError {}
